export default "__VITE_ASSET__491c0e08__"